export default __webpack_public_path__ + "static/media/focus.5b373a3b.svg";